<template>
  <div class="product-template __donate  __limited-edu __limited-edu--uob __uob-heartbeat-2024 __uob-heartbeat-2024--ticket">
    <div class="container pd-sm-0">
      <div class="col-md-push-2 col-md-8">
        <div class="text-center mb-10 wrap-logo">
          <img src="/static/img/uob/logo-uob-heartbeat-2025@2x.png" srcset="/static/img/uob/logo-uob-heartbeat-2025@2x.png" alt="UOB Heartbeat" style="width: 260px" class="logo pd-15 ma-auto d-block" />
        </div>
        <h3 class="text-center mb-10">ทุก 100 บาท = 1 สิทธิ์ลุ้นรางวัล</h3>
        <div class="text-center text-primary mb-20">ระดมทุนสนับสนุนการพัฒนาคุณภาพการศึกษา<br />และสร้างโอกาสทางการเรียนรู้ที่ยั่งยืน ในโครงการ UOB My Digital Space</div>
      </div>
    </div>
    <div class="container pd-sm-0">
      <div class="col-md-push-1 col-md-10 col-lg-push-1 col-md-10">
        <div class="product product--inline">
          <div class="product__block--form">
            <div class="radius block shadow">
              <product-donate-choice
              :show-donate-type="true"
              :product="product"
              v-model="product.price"
              ref="donateChoice"
              classes="col-1-5" />
              <div class="row">
                <div class="col-sm-12 col-md-6">
                    <!-- ตำแหน่ง -->
                    <div class="pt-15">
                        <div><strong>ระบุตำแหน่ง <span style="color: #E82B27">*</span></strong></div> 
                        <div class="form__select">
                            <!-- rewardConfigChoice (ตำแหน่ง) -->
                            <select v-model="attributes.info.rewardConfigChoice">
                                <option value="">-- โปรดระบุตำแหน่ง --</option>
                                <option
                                v-for="LevelOption in LevelOptions"
                                :key="LevelOption.text"
                                :value="LevelOption.description"
                                >
                                {{ LevelOption.description }}
                                </option>
                            </select>
                        </div>
                        <div class="alert alert--error" v-if="error.rewardConfigChoice">กรุณาระบุตำแหน่ง</div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <!-- หน่วยงาน -->
                    <div class="pt-15">
                        <div><strong>ระบุหน่วยงานของท่าน <span style="color: #E82B27">*</span></strong></div> 
                        <div class="form__select">
                            <!-- rewardConfigText (หน่วยงาน) -->
                            <select v-model="attributes.info.rewardConfigText">
                                <option value="">-- โปรดระบุหน่วยงาน --</option>
                                <option
                                v-for="FunctionOption in FunctionOptions"
                                :key="FunctionOption.text"
                                :value="FunctionOption.description"
                                >
                                {{ FunctionOption.description }}
                                </option>
                            </select>
                        </div>
                        <div class="alert alert--error" v-if="error.rewardConfigText">กรุณาระบุหน่วยงานของท่าน</div>
                    </div>
                </div>
              </div>
              <page-selector
                :product="product"
                v-model="attributes.page"
                v-show="false" />

              <product-cart-action
                :product="product"
                :attributes="attributes"
                :initialQuantity="1"
                :addToCartButton="false"
                :buyNowButton="false"
                :style="{margin:0}"
                ref="cartAction" />
              <div class="text-center">
                <button type="button" class="btn btn--purple btn--default" @click.prevent="donate">บริจาค</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DonorInfo from '@/components/DonorInfo'
  import PageSelector from '@/components/PageSelector'
  import ProductCartAction from '@/components/ProductCartAction'
  import ProductDonateChoice from '@/components/ProductDonateChoice'
  export default {
    name: 'ProductTemplateUOBxLimitedEducation2024',

    components: {
      DonorInfo,
      PageSelector,
      ProductCartAction,
      ProductDonateChoice
    },
    props: {
      title: { type: String, default: 'บริจาค' },
      product: { type: Object, required: true }
    },
    data () {
      return {
        tshirtProductName: 'UOB 2024 Ticket',
        attributes: {
          info: {
            name: '',
            rewardConfigChoice: '',
            rewardConfigText: ''
          },
          page: ''
        },
        error: {
          rewardConfigChoice: false,
          rewardConfigText: false
        }
      }
    },
    computed: {
      // ตำแหน่ง
      LevelOptions () {
        // 1:Managing Director,2:Executive Director
        return this.product.meta.donation_level_option.split(',').map(row => {
          const [ text, description ] = row.split(':')
          return { text, description }
        })
      },
      // หน่วยงาน
      FunctionOptions () {
        // 1:Personal Financial Services, 2:Project Management Office
        return this.product.meta.donation_function_option.split(',').map(row => {
          const [ text, description ] = row.split(':')
          return { text, description }
        })
      }
    },
    methods: {
      validate () {
        this.error.rewardConfigChoice = false
        this.error.rewardConfigText = false
        this.error.name = false
        let valid = true
        const {info} = this.attributes
        // Validate size selection.
        if (!info.rewardConfigChoice) {
          this.error.rewardConfigChoice = true
          valid = false
        } else if (!info.rewardConfigText) {
          this.error.rewardConfigText = true
          valid = false
        }
        return valid
      },
      async donate () {
        if (!this.$refs.donateChoice.validate()) {
          return
        }
        if (!this.validate()) {
          return
        }
        if (this.product.meta.receipt_item_description) {
          this.attributes.info._receiptItemDescription = this.product.meta.receipt_item_description
        }
        // Clear previous cart info.
        await this.$store.dispatch('clearCart')
        // Add donation product to cart and go to checkout.
        this.$refs.cartAction.buyNow()
      }
    }
  }
</script>

<style lang="scss" scoped>

  h1.page-title {
    color: #fff;
    font-size: 2em;
    font-weight: 500;
    margin-bottom: 15px;
  }
  h3 {
    color:#fff;
  }
  .text-primary {
    color: #fff;
  }
  .block { background: #fff; }
  .btn--default {
    margin: 20px auto 10px;
  }

</style>



// WEBPACK FOOTER //
// uob-lucky-draw-2025.vue?58c79dfd